'use strict';
const mmWidgets = require('./mm-widgets'),
	pasteText = function (e) {
		const element = e.target,
			contentEditable = element && element.hasAttribute('contenteditable'),
			text = contentEditable && e.clipboardData && e.clipboardData.getData('text/plain');
		if (!text) {
			return;
		}
		// cancel paste
		e.preventDefault();
		// insert text manually
		document.execCommand('insertText', false, text);
	};

mmWidgets.fn.textOnlyPasteWidget = function () {
	return mmWidgets.each(this, function () {
		this.domElements.forEach(element => element.addEventListener('paste', pasteText));
	});
};
